export const COLOR_NAVY_BLUE = '#1b3550';
export const COLOR_YELLOW = '#ffb300';
export const COLOR_CYAN = '#1dc3a4';

export const FRAUD_SIGNAL_BOUNDING_BOX_COLOR_RGBA = 'rgba(229, 72, 77, 0.3)';
export const FRAUD_SIGNAL_BOUNDING_BOX_COLOR_RGBA_OPAQUE =
  'rgba(229, 72, 77, 1)';
export const NEUTRAL_SIGNAL_BOUNDING_BOX_COLOR_HEX = '#8E8C99';
export const NEUTRAL_SIGNAL_BOUNDING_BOX_COLOR_RGBA =
  'rgba(142, 140, 153, 0.5)';
